import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';
import {
    FULL_COMPOSE_FORM_TYPE,
    QUICK_COMPOSE_FORM_TYPE,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import {
    QUICK_COMPOSE_ENTRY_SOURCE_TIMEPANEL_NEW_BUTTON,
    QUICK_COMPOSE_ENTRY_SOURCE_TIMEPANEL_SURFACE,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

export default function getCalendarComponent(): CalendarComponent {
    const { openedForm } = getComposeStore();
    switch (openedForm) {
        case QUICK_COMPOSE_FORM_TYPE:
            if (isMyDayPanelQuickComposeForm()) {
                return CalendarComponent.MyDayPanelCompose;
            }
            return CalendarComponent.CalendarQuickCompose;
        case FULL_COMPOSE_FORM_TYPE:
            return CalendarComponent.CalendarFullCompose;
        default:
            return CalendarComponent.Unknown;
    }
}

function isMyDayPanelQuickComposeForm(): boolean {
    const { metricsInfo } = getComposeStore();
    return (
        metricsInfo?.quickComposeEntrySource == QUICK_COMPOSE_ENTRY_SOURCE_TIMEPANEL_NEW_BUTTON ||
        metricsInfo?.quickComposeEntrySource == QUICK_COMPOSE_ENTRY_SOURCE_TIMEPANEL_SURFACE
    );
}
